import { ListChecks } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import type { Task } from "../../mock/types";
import { checklistPct } from "../../mock/helpers";

export function ChecklistSection({
	task,
	onToggle,
}: {
	task: Task;
	onToggle: (itemId: string) => void;
}) {
	if (task.checklist.length === 0) return null;
	const done = task.checklist.filter((c) => c.done).length;
	const pct = checklistPct(task);

	return (
		<section>
			<div className="mb-2 flex items-center gap-2">
				<ListChecks className="h-4 w-4 text-muted" />
				<h3 className="text-sm font-semibold text-foreground">
					Checklist
				</h3>
				<span className="text-xs text-muted">
					{done}/{task.checklist.length}
				</span>
			</div>
			<div className="mb-3 h-1.5 rounded-full bg-muted-subtle overflow-hidden">
				<div
					className="h-full bg-primary transition-all"
					style={{ width: `${pct}%` }}
				/>
			</div>
			<ul className="space-y-1.5">
				{task.checklist.map((item) => (
					<li key={item.id}>
						<label className="flex items-center gap-2 rounded-md px-1.5 py-1 hover:bg-muted-subtle cursor-pointer">
							<Checkbox
								checked={item.done}
								onCheckedChange={() => onToggle(item.id)}
							/>
							<span
								className={
									item.done
										? "text-sm text-muted line-through"
										: "text-sm text-foreground"
								}
							>
								{item.label}
							</span>
						</label>
					</li>
				))}
			</ul>
		</section>
	);
}
